import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-erinnerung-versenden';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeErinnerungVersendenEffects {

    AufgabeErinnerungVersenden$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_ERINNERUNG_VERSENDEN),
        mergeMap((x: ac.PostAufgabeErinnerungVersendenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeErinnerungVersenden(x.aufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeErinnerungVersendenErfolgreichAction(result, x.aufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeErinnerungVersendenFehlerAction(error, x.aufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
